import { EBookType, EGenre, ELanguage } from "../../models/book";

export const DEFAULT_BOOK_INPUTS = {
  title: "",
  author: "",
  language: ELanguage.ENGLISH_US,
  book_type: EBookType.NON_FICTION,
  genre: EGenre.FINANCE,
  thesis: "",
  audience: "",
  draft_toc: "",
  author_bio: "",
  steering_instructions: "",
  copyright_agreement: false,
} as const;
